/**
 * Recruit Filter - Frontend Script
 */
document.addEventListener('DOMContentLoaded', () => {
	const moreBtns =
		document.querySelectorAll<HTMLButtonElement>(
			'.recruit-filter__more-btn'
		);

	moreBtns.forEach((btn) => {
		btn.addEventListener('click', () => {
			const fieldset = btn.closest('.recruit-filter__fieldset');
			if (fieldset) {
				fieldset.classList.add('is-expanded');
			}
		});
	});
});
